import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-map-project" }
const _hoisted_2 = {
  key: 0,
  class: "content-map-project__description-list"
}
const _hoisted_3 = {
  key: 1,
  class: "special-territory-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('countryClick', _ctx.state.id))),
      class: "content-map-project__name"
    }, _toDisplayString(_ctx.state.countryName), 1),
    (!_ctx.state.isSpecialTerritory)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          _createElementVNode("li", null, [
            _cache[2] || (_cache[2] = _createTextVNode(" Всего проектов: ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.state.countProjects), 1)
          ]),
          _createElementVNode("li", null, [
            _cache[3] || (_cache[3] = _createTextVNode(" Проектов по линии МПК: ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.state.countMpkProjects), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "special-territory-info-text" }, "Это специальный административный район", -1)),
          _createVNode(_component_ButtonComponent, {
            mod: "gradient-bg",
            class: "btnShowSpecReg",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('specialTerritoryClick')))
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Просмотр", -1)
            ]))]),
            _: 1
          })
        ]))
  ]))
}